import { createContext, useContext } from "react";
var context = createContext(false);
if (process.env.NODE_ENV !== "production") {
    context.displayName = "TableFooterContext";
}
/**
 * @internal
 */
export var TableFooterProvider = context.Provider;
/**
 * @internal
 */
export function useTableFooter() {
    return useContext(context);
}
//# sourceMappingURL=footer.js.map